import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { getCustomStyles } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";
import { exportCurrentEcosystemDetails } from "components/Common/Ecosystem/EcosystemInfo";


const AboutAccordion = ({
  validation = {},
  setValidation,
  firstName = "",
  setFirstName,
  lastName = "",
  setLastName,
  emailAddress = "",
  setEmailAddress,
  website = "",
  setWebsite,
  phoneNumber = "",
  setPhoneNumber,
  dateOfBirth = "",
  setDateOfBirth,
  companyOptionsToShow = [],
  companyValue = null,
  companySelectionHandler,
  setcompanyInput,
  position = "",
  setposition,
  linkdin = "",
  setLinkdin,
  mentorOptionsToShow = [],
  mentorValue = null,
  mentorSelectionHandler,
  mentorInputHandler,
  followersOptionsToShow = [],
  followrsValue = null,
  followersSelectionHandler,
  onFollowersInputChange,
  openImageFileInput,
  imageFileInputRef,
  imageUploadHandler,
  isUploading = false,
  closeLeadImageFileHandler,
  uploadedPreviewImage = "",
  about = "",
  setAbout,
  interest = "",
  setInterest,
  leadHobbiesValue = null,
  hobbiesSelectionHandler,
  SubscribeOptions = [],
  subscribeMailValue = null,
  subscribeSelectionHandler,
  subscribeAcceptOn = "",
  setSubscribeAcceptOn,
  subscribeDeninedOn = "",
  setSubscribeDeninedOn,
  interestValue = [],
  industryValue = [],
  setInterestValue,
  setIndustryValue,
}) => {
  const { t } = useTranslation();

  // Add local state for options
  const [interestOptions, setInterestOptions] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);

  const fetchEcosystemOptions = async () => {
    const data = await exportCurrentEcosystemDetails();
    if (data) {
      setInterestOptions(
        data.interest
          ? data.interest.map((item) => ({
              label: item,
              value: item,
            }))
          : []
      );
      setIndustryOptions(
        data.industry
          ? data.industry.map((item) => ({
              label: item,
              value: item,
            }))
          : []
      );
    }
  }

  useEffect(() => {
    fetchEcosystemOptions();
  }, []);


  const handleInterestChange = (selectedOptions) => {
    setInterestValue(selectedOptions ? selectedOptions.map(opt => opt.value) : []);
  }

  const handleIndustryChange = (selectedOptions) => {
    setIndustryValue(selectedOptions ? selectedOptions.map(opt => opt.value) : []);
  }

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseOne"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseOne"
        >
          {t("About")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}
      {/* ------ about section start ------ */}
      <div
        id="panelsStayOpen-collapseOne"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          {/* First / Last Name */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("First Name")}
                </label>
                <input
                  type="text"
                  id="fName"
                  className={`form-control fs-sm shadow-none ${
                    validation.firstNameWarning
                      ? "is-invalid"
                      : "border border-gray-300"
                  }`}
                  placeholder={t("First Name")}
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                    setValidation((prevState) => ({
                      ...prevState,
                      firstNameWarning: false,
                    }));
                  }}
                />
                {validation.firstNameWarning && (
                  <div className="invalid-feedback fs-md">
                    {t("Please enter a name")} *
                  </div>
                )}
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Last Name")}
                </label>
                <input
                  type="text"
                  id="lName"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Last Name")}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Email / Website */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Email")}
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("Email Address")}
                  value={emailAddress}
                  onChange={(e) => {
                    setEmailAddress(e.target.value);
                    setValidation((prevState) => ({
                      ...prevState,
                      emailAddressWarning: false,
                      notValidMail: false,
                    }));
                  }}
                />
                {validation.emailAddressWarning && (
                  <div className="error-message mt-2">
                    <p className="d-flex align-items-center gap-1 text-danger mb-0">
                      <span className="material-symbols-outlined">warning</span>
                      <span>{t("Please enter email")}!</span>
                    </p>
                  </div>
                )}
                {validation.notValidMail && (
                  <div className="error-message mt-2">
                    <p className="d-flex align-items-center gap-1 text-danger mb-0">
                      <span className="material-symbols-outlined">warning</span>
                      <span>{t("Please enter a vaild email")}!</span>
                    </p>
                  </div>
                )}
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Website")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Enter website")}
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Phone / DOB */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Phone")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Phone")}
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("DOB")}
                </label>
                <input
                  type="date"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder="DD"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Company / Position */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Company")}
                </label>
                <div className="d-flex align-items-center gap-3">
                  <CreatableSelect
                    className="w-100"
                    placeholder={t("Type Company name")}
                    isClearable
                    options={companyOptionsToShow}
                    value={companyValue}
                    onChange={(val) => companySelectionHandler(val)}
                    onInputChange={(val) => setcompanyInput(val)}
                    styles={getCustomStyles()}
                  />
                  <Link
                    to="/admin/companies/info"
                    target="_blank"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <span className="d-block material-symbols-outlined icon-fill">
                      add
                    </span>
                  </Link>
                </div>
                {validation.companyWarning && (
                  <div className="error-message mt-2">
                    <p className="d-flex align-items-center gap-1 text-danger mb-0">
                      <span className="material-symbols-outlined">warning</span>
                      <span>{t("Please enter a company")}!</span>
                    </p>
                  </div>
                )}
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Position")}
                </label>
                <input
                  type="text"
                  id="position"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Enter position")}
                  value={position}
                  onChange={(e) => setposition(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Interest */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Interest")}
            </label>
            <Select
              isMulti
              className="w-100"
              placeholder={t("Select interests")}
              options={interestOptions}
              value={interestOptions.filter(opt => interestValue.includes(opt.value))}
              onChange={handleInterestChange}
            />
          </div>

          {/* Industry */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Industry")}
            </label>
            <Select
              isMulti
              className="w-100"
              placeholder={t("Select industries")}
              options={industryOptions}
              value={industryOptions.filter(opt => industryValue.includes(opt.value))}
              onChange={handleIndustryChange}
            />
          </div>

          {/* Linkdin */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Linkdin")}
            </label>
            <input
              type="text"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Enter url")}
              value={linkdin}
              onChange={(e) => setLinkdin(e.target.value)}
            />
          </div>

          {/* Mentor */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Mentor (contact who provided this lead)")}
            </label>
            <Select
              isClearable
              className="w-100"
              placeholder={t("Search by name, email")}
              options={mentorOptionsToShow}
              value={mentorValue}
              onChange={(val) => mentorSelectionHandler(val)}
              onInputChange={(val) => mentorInputHandler(val)}
              styles={getCustomStyles()}
            />
          </div>

          {/* Followers */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Followers")}
            </label>
            <Select
              isMulti
              className="w-100"
              placeholder={t("Search by name,email")}
              options={followersOptionsToShow}
              value={followrsValue}
              onChange={(val) => followersSelectionHandler(val)}
              onInputChange={(val) => onFollowersInputChange(val)}
              styles={getCustomStyles()}
            />
          </div>

          {/* Upload DP */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Upload DP")}
            </label>
            <FileUploadField
              label={t("Upload DP")}
              accept="jpg png jpeg"
              onUpload={imageUploadHandler}
              files={
                uploadedPreviewImage === ""
                  ? [
                      {
                        path: "https://placehold.co/150x150",
                        name: "Upload DP",
                      },
                    ]
                  : [
                      {
                        path: uploadedPreviewImage,
                        name: "Upload DP",
                      },
                    ]
              }
              onRemove={() => {
                closeLeadImageFileHandler();
              }}
              loading={isUploading}
              fileType="image"
            />
          </div>

          {/* Description */}
          <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
            <JoditEditorField
              label={t("About")}
              labelClassName="d-block fs-sm fw-semibold mb-2"
              value={about}
              onChange={(newContent) => setAbout(newContent)}
              editorHeight={250}
            />
          </div>

          {/* Professional Interest */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Professional Interest")}
            </label>
            <input
              type="text"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Enter Interest")}
              value={interest}
              onChange={(e) => setInterest(e.target.value)}
            />
          </div>

          {/* Hobbies / Subscribe to commercial emails */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Hobbies")}
                </label>
                <CreatableSelect
                  isMulti
                  className="w-100"
                  placeholder={t("Type Hobbies")}
                  value={leadHobbiesValue}
                  onChange={(val) => hobbiesSelectionHandler(val)}
                  styles={getCustomStyles()}
                />
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Subscribe to commercial emails")}
                </label>
                <Select
                  className="w-100"
                  options={SubscribeOptions}
                  value={subscribeMailValue}
                  onChange={(val) => subscribeSelectionHandler(val)}
                  styles={getCustomStyles()}
                />

                <div className="row mt-3">
                  {subscribeAcceptOn === "" ? null : (
                    <div className="col-lg-6 mb-3 mb-lg-0">
                      <label className="d-block fs-sm fw-semibold mb-2">
                        {t("Subscribe accept on")}
                      </label>
                      <input
                        type="date"
                        className="form-control fs-sm border border-gray-300 shadow-none"
                        value={subscribeAcceptOn}
                        onChange={(e) => setSubscribeAcceptOn(e.target.value)}
                      />
                    </div>
                  )}

                  {subscribeDeninedOn === "" ? null : (
                    <div className="col-lg-6">
                      <label className="d-block fs-sm fw-semibold mb-2">
                        {t("Subscribe denied on")}
                      </label>
                      <input
                        type="date"
                        className="form-control fs-sm border border-gray-300 shadow-none"
                        value={subscribeDeninedOn}
                        onChange={(e) => setSubscribeDeninedOn(e.target.value)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ------ about section end ------ */}
    </div>
  );
};

export default AboutAccordion;
